module.exports = __webpack_public_path__ + "static/media/virtual_front.e2c47d72.svg";